import OpenDebts from './OpenDebts';
import PaymentHistory from './PaymentHistory';
import BuyReportWrapper from '../components/BuyReportWrapper';

const NegativeData = ({ handleBuyReport }) => {
  return (
    <BuyReportWrapper type={'negativeData'} handleBuyReport={handleBuyReport}>
      <OpenDebts />
      <PaymentHistory />
    </BuyReportWrapper>
  );
};

export default NegativeData;
